import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import useReveal from './useReveal';
import './PhotoCarousel.css';

function PhotoCarousel({ photos }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [ref, visible] = useReveal();
  const active = photos[activeIndex];
  const total = String(photos.length).padStart(2, '0');

  return (
    <section ref={ref} className={`carousel-section${visible ? ' is-visible' : ''}`}>
      <header className="carousel-heading">
        <p className="section-eyebrow">Gallery</p>
        <h2 className="section-title">Our photos</h2>
      </header>

      {photos.length === 0 ? (
        <div className="carousel-placeholder">
          <span className="carousel-placeholder-icon">📷</span>
          <span>Photos coming soon</span>
        </div>
      ) : (
        <>
          <Swiper
            className="carousel-swiper"
            modules={[Navigation, Keyboard]}
            navigation
            keyboard={{ enabled: true }}
            slidesPerView="auto"
            centeredSlides
            spaceBetween={14}
            grabCursor
            loop={photos.length > 1}
            onRealIndexChange={(swiper) => setActiveIndex(swiper.realIndex)}
          >
            {photos.map(({ filename, width, height }) => (
              <SwiperSlide
                key={filename}
                style={width && height ? { aspectRatio: `${width} / ${height}` } : undefined}
              >
                <div className="carousel-frame">
                  <img src={`/photos/carousel/${filename}`} alt="" loading="lazy" />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="carousel-footer">
            <div className="carousel-caption">
              <span className="carousel-date">{active ? active.fullDate : ''}</span>
              <span className="carousel-index">
                {String(activeIndex + 1).padStart(2, '0')} / {total}
              </span>
            </div>
            <div className="carousel-progress" aria-hidden="true">
              <div
                className="carousel-progress-fill"
                style={{ width: `${((activeIndex + 1) / photos.length) * 100}%` }}
              />
            </div>
          </div>
        </>
      )}
    </section>
  );
}

export default PhotoCarousel;
